import type { ProductSchema } from 'data-layer';

interface ProductSchemaScriptProps {
  schema: ProductSchema;
}

export function ProductSchemaScript({ schema }: ProductSchemaScriptProps) {
  return (
    <script
      id="product-schema-jsonld"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
